export const STATUSES_OK = [
  'OK',
  'APPROVED',
  'SUCCESS',
];

export const STATUSES_PENDING = [
  'PENDING',
  'PENDING_BUYER',
  'PENDING_MERCHANT',
];

export const STATUS_CANCEL = 'CANCEL';



// WEBPACK FOOTER //
// ./src/shared/constants/payment-statuses.js